export function getLengthOfResidencyInMonths({ years, months }) {
  if (years && !months) {
    return parseInt(years, 10) * 12;
  }
  if (!years && months) {
    return parseInt(months, 10);
  }
  return parseInt(years, 10) * 12 + parseInt(months, 10);
}
